/** Значение ячейки, которое агент может передать в тулзу без дополнительных обёрток. */
export type ExcelInputCellValue = string | number | boolean | null;

/** Значение ячейки после нормализации: даты уже приведены к `Date`. */
export type ExcelCellValue = string | number | boolean | Date | null;

/** Поддерживаемые типы колонок: влияют на приведение значений и формат. */
export type ExcelColumnType = 'auto' | 'number' | 'date' | 'text';

/** Нормализованное и провалидированное описание выгрузки. */
export interface NormalizedExcelSpec {
    /** Имя файла вместе с расширением `.xlsx`. */
    fileName: string;
    /** Имя листа. */
    sheetName: string;
    /** Необязательная строка заголовков. */
    columns: string[];
    /** Данные без строки заголовков. */
    rows: ExcelCellValue[][];
    /** Ширины колонок (может быть короче числа колонок). */
    columnWidths: number[];
    /** Excel-формат ячеек по колонкам (`null` — без формата). */
    columnFormats: (string | null)[];
    /** Тип колонки по индексу (может быть короче числа колонок). */
    columnTypes: ExcelColumnType[];
    /** Итоговое число колонок (учитывает заголовки и самую широкую строку). */
    columnCount: number;
}

/** Готовый файл, сохранённый на клиенте. */
export interface ExcelFileRecord {
    id: string;
    fileName: string;
    sheetName: string;
    rowCount: number;
    columnCount: number;
    size: number;
    createdAt: number;
    blob: Blob;
}

/** Компактные сведения о созданном файле — их получает агент. */
export interface ExcelFileInfo {
    fileId: string;
    fileName: string;
    sheetName: string;
    rowCount: number;
    columnCount: number;
    size: number;
}

/** Результат сборки файла. */
export type ExcelFileCreateResult =
    | { status: 'ok'; info: ExcelFileInfo }
    | { status: 'error'; code: string; message: string };

/** Коды ошибок, по которым агент должен исправить аргументы. */
export const EXCEL_ERROR_CODE = {
    invalidArgs: 'invalid_args',
    invalidRows: 'invalid_rows',
    invalidColumns: 'invalid_columns',
    invalidColumnWidths: 'invalid_column_widths',
    invalidColumnFormats: 'invalid_column_formats',
    invalidColumnTypes: 'invalid_column_types',
    invalidFormatForColumn: 'invalid_format_for_column',
    invalidDateValue: 'invalid_date_value',
    invalidNumberValue: 'invalid_number_value',
    unsupportedCellType: 'unsupported_cell_type',
    cellTooLong: 'cell_too_long',
    rowsTooLarge: 'rows_too_large',
    tooManyColumns: 'too_many_columns',
    tooLarge: 'too_large',
    generationFailed: 'generation_failed',
} as const;
